// extracted by mini-css-extract-plugin
export default {"wrapper":"Icon_wrapper__HMreB","small":"Icon_small__O0Z+u","medium":"Icon_medium__Ngdhj","large":"Icon_large__eFRaK"};